import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FilledLoading from "../loader/FilledLoading";
import { getInvitationDetailsSelf } from "../../../store/reducers/invitationReducer";
import { InvDiv } from "../Style";
import Output from "./Output";
import Names from "./Names";
import Links from "./Links";
import Footer from "./Footer";
import Extra from "./Extra";
import GenericArivalConfirmation from "./GenericArivalConfirmation";
import { handleClickScroll } from "../others/Functions";
//
const SelfInvitation = () => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const search = useLocation().search;
  const { token } = useParams();

  const getId = (num) => {
    let name = new URLSearchParams(search).get("s");
    name = window.atob(name);
    name = name.split(" ");
    return name[num];
  };

  // useEffect(() => {
  //   setLoading(true);
  //   dispatch(getInvitationDetails({ token })).then((res) => {
  //     // console.log(res.payload?.error);
  //     if (res.payload?.error) toast.error("חלה שגיאה, יש לנסות לרענן...");
  //     else setDetails(res.payload);
  //   });
  // }, []);

  useEffect(() => {
    setLoading(true);
    dispatch(getInvitationDetailsSelf({ token })).then((res) => {
      setLoading(false);
      if (res.payload?.error) toast.error("חלה שגיאה, יש לנסות לרענן...");
      else setDetails(res.payload);
    });
  }, []);

  useEffect(() => {
    setTimeout(function () {
      handleClickScroll("bla");
    }, 2000);
  }, []);

  const borderedInvsStyle = {
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.7)",
    boxShadow: "0 1px 2px silver",
    padding: "5px",
    boxShadow: "0 2px 4px silver",
    borderRadius: "3px",
    paddingBottom: "20px",
  };
  const basicDivStyle =
    details?.invK === 1 ? { width: "100%" } : borderedInvsStyle;

  return (
    <>
      {details ? (
        <InvDiv
          gradient={details.gradient}
          style={{
            width: "100%",
            height: `${window.screen.availHeight}px`,
            height: "100%",
            padding: details.invK === 1 ? "0" : "15px",
            // maxHeight: "800px",
            position: "relative",
          }}
        >
          <div style={{ ...basicDivStyle }}>
            <Output
              _id={details._id}
              pic={details.pic}
              picPosition={details.picPosition}
              cropAreaAspect={details.cropAreaAspect}
            />
            {details.inv === 1 && (
              <Names data={details} heartColor={details.heartColor} />
            )}
            <GenericArivalConfirmation
              // gId={getId(1)}
              // uId={getId(0)}
              self={true}
              token={token}
              heartColor={details.heartColor}
              acceptLimit={details.acceptLimit}
              specialDishes={details.specialDishes}
              transportation={details.transportation}
              specialMsg={details.specialMsg}
              specialMsgDetails={details.specialMsgDetails}
              blessing={details.blessing}
              blessTitle={details.blessTitle}
              transportationDetails={details.transportationDetails}
              invK={details.invK}
              separation={details.separation}
              seuda={details.seuda}
            />
            {details.inv === 1 && <Extra data={details} />}
            <Links data={details} />
            {/* לעשות כמו בי סימפל */}
          </div>
          {/* <div style={{ height: "200px" }} /> */}
          <Footer producer={details.producer} />
          {loading && <FilledLoading />}
        </InvDiv>
      ) : (
        <FilledLoading />
      )}
    </>
  );
};

export default SelfInvitation;
